import { apis } from '../../services/api';
import cache, {keys} from '../../services/cache';
import globalStore from '../index';

let companyApi = apis.companyApi;

const state = {
    config: null,
    terms: ''
};

const getters = {
    config: state => state.config,
    zonas: state => state.config.zonas,
    cancelReasonModuleEnabled: state => {
        let cancelWithReasonPreLoaded = false;
        if (state.config.modulo_razon_cancelacion && state.config.razones_cancelacion) {
            let iamDriver = globalStore.getters['auth/isChofer'] !== null;
            if (iamDriver && state.config.razones_cancelacion.driver) {
                cancelWithReasonPreLoaded = true;
            }
            if (!iamDriver && state.config.razones_cancelacion.passenger) {
                cancelWithReasonPreLoaded = true;
            }
            console.log('cancelWithReasonPreLoaded', cancelWithReasonPreLoaded);
        }
        return state.config.modulo_motivo_cancelacion || cancelWithReasonPreLoaded;
    },
    terms: state => state.terms
};

const actions = {
    getConfig (store) {
        companyApi.index().then(data => {
            // data.modulo_precio_viaje = true;
            // data.modulo_destino_viaje = true;
            if (store.rootState.auth.user) {
                console.log('is tester', store.rootState.auth.user.tester);
                data.modulo_precio_viaje = data.modulo_precio_viaje || store.rootState.auth.user.tester;
            }
            if (data.modulo_precio_viaje) {
                data.modulo_destino_viaje = true;
            }

            // Para testear rápido los flags
            // data.modulo_pasajero_mascotas = true;
            // data.modulo_pasajero_maletas = true;
            // data.modulo_pasajero_silla_ruedas = true;
            // data.modulo_pasajero_viaje_afuera = true;
            // data.modulo_chofer_vehiculo_color = true;

            // data.zonas[0].radio = 10000;
            // data.zonas[0].lat = -38.954450236450576;
            // data.zonas[0].lng = -68.23884481736388;

            store.commit('SET_CONFIG', data);
            cache.setItem(keys.COMPANY_KEY, data);
        }).catch(error => {
            // [ToDo - handle error]
            console.error(error);
        });
    },
    getTerms (store, lang) {
        companyApi.terms(lang).then(data => {
            store.commit('SET_TERMS', data.content);
        }).catch(error => {
            // [ToDo - handle error]
            console.error(error);
        });
    }
};

const mutations = {
    SET_CONFIG (state, value) {
        state.config = value;
    },

    SET_TERMS (state, value) {
        state.terms = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js